export default __webpack_public_path__ + "static/media/puzle.d573479b.svg";